<template lang="pug">
  .flow-builder-action-show-products-template
    template-tools(v-if="!disabled", @delete="$emit('delete')")
    .template-platforms-container.badges.mb-3(v-if="disabled")
      b-badge(v-for="(platform) in selectedPlatformsObjects.slice(0, sliceEnd)", :key="platform.platform_id", :style="{'background-color': platformColor(platform.name, 0.7)}") {{ platform.title }}
      b-badge(v-if="selectedPlatformsObjects.slice(sliceEnd).length", variant="soft-secondary") {{ selectedPlatformsObjects.slice(sliceEnd).length }} más
    .template-platforms-container.overflow-x.no-wrap.mb-3(v-else)
      b-form-group
        label.text-help.text-sm Plataformas donde se usará este template:
        k-select.disabled-white.flush(placeholder="- Agregar plataformas -", :options="parsedPlatforms", :disabled="disabled", :value="selected_platforms", @input="updatePlatforms", multiple, :limit="3", :searchable="false")
    b-card.mb-0.no-shadow.w-100.bg-light-white
      .bg-white.mb-3
        p.mb-0 Enviar email ✉️
        p.text-secondary.text-sm Envía un correo electrónico especificando el destinatario y remitente.
        //result-description.mb-3(variable-name="web", variable-type="object")
        fieldset.mb-3(:disabled="disabled")
          b-form-group(label-size="sm", label="Remitente:", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'from'")
            vue-tribute(:options="tributeOpts")
              b-form-input.disabled-white(size="sm", placeholder="Remitente", :value="template_attribute.value", @blur="updateTemplateAttribute(template_attribute, $event)")
          b-form-group(label-size="sm", label="Nombre de remitente:", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'from_name'")
            vue-tribute(:options="tributeOpts")
              b-form-input.disabled-white(size="sm", placeholder="Nombre de remitente", :value="template_attribute.value", @blur="updateTemplateAttribute(template_attribute, $event)")
          b-form-group(label-size="sm", label="Destinatario:", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'to'")
            vue-tribute(:options="tributeOpts")
              b-form-input.disabled-white(size="sm", placeholder="Destinatario", :value="template_attribute.value", @blur="updateTemplateAttribute(template_attribute, $event)")
          b-form-group(label-size="sm", label="Asunto:", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'subject'")
            vue-tribute(:options="tributeOpts")
              b-form-input.disabled-white(size="sm", placeholder="Asunto", :value="template_attribute.value", @blur="updateTemplateAttribute(template_attribute, $event)")
          b-form-group(label-size="sm", label="ID de template (Sendgrid):", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'email_template_id'")
            vue-tribute(:options="tributeOpts")
              b-form-input.disabled-white(size="sm", placeholder="Template Id (Sendgrid)", :value="template_attribute.value", @blur="updateTemplateAttribute(template_attribute, $event)")
          b-form-group(label-size="sm", label="JSON Sendgrid Template:", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'email_template_json'")
            vue-tribute(:options="tributeOpts")
              b-form-textarea.disabled-white(size="sm", no-resize, max-rows="100", placeholder="JSON", :value="template_attribute.value", @blur="updateTemplateAttribute(template_attribute, $event)", @focusout="isJson($event)")
          b-form-checkbox.mb-3(switch, v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'attach_log'", :checked="parseBoolean(template_attribute.value)", @change="updateTemplateAttribute(template_attribute, $event)") {{template_attribute.value ? 'Sí' : 'No' }} añadir conversación al correo
          .mb-3(:id="'html_' + uuid")
          b-form-group(label-size="sm", label="Archivos adjuntos", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'attachment'")
            b-input-group.mb-3(size="sm")
              b-form-input.disabled-white(size="sm", placeholder="Agregar URL", v-model="url_attachment", @input="pushURL")
              b-input-group-append
                b-button(size="sm", variant="soft-primary", @click="clickInput", :disabled="loading")
                  b-spinner(small, variant="primary", v-if="loading")
                  paperclip-icon.icon-sm(v-else)
            .d-flex.align-items-center.justify-content-between(v-for="(attachment, index) in attachments", :key="index")
              b-link.flex-grow-1(:href="attachment.file", target="_blank") {{attachment.name}}
              x-icon.icon-md.hover-danger.pointer(@click="removeAttachment(index)")
        input.d-none(type="file", accept="image/*", :ref="uuid", @change="uploadImage($event.target.files).then(() => {})")
</template>

<script>
import templateCommon from '../../helpers/template-common'
import Connector from './connectors/Connector.vue'
import TemplateTools from './common/Tools.vue'
import _debounce from 'lodash.debounce'
import { UploadFile } from '../../helpers/upload-file'
import uuid from '../../helpers/uuid-generator'
import { mapActions } from 'vuex'
import pell from 'pell'

export default {
  mixins: [templateCommon],
  data () {
    return {
      url_attachment: "",
      loading: false,
      uuid: null
    }
  },
  computed: {
    attachments () {
      let template_attribute = this.getAttribute('attachment')
      if (template_attribute) {
        let value = JSON.parse(template_attribute.value)
        return value.map((el, i) => {
          let name = el.split('/').pop()
          return {
            file: el,
            name: name ? decodeURIComponent(name) : 'archivo_' + i
          }
        })
      } else {
        return []
      }
    }
  },
  methods: {
    ...mapActions(['helpers/upload_file']),
    pushURL: _debounce(() => {
      this.attachURL(this.url_attachment)
      this.url_attachment = ''
    }, 100, { leading: false, trailing: true }),
    clickInput () {
      this.$refs[this.uuid].click()
    },
    async uploadImage (files) {
      this.loading = true
      try {
        let image = await UploadFile.call(this, files[0])
        this.attachURL(image)
      } catch (e) {
        console.log(e)
        this.$message.warning('No logramos subir la imagen, por favor comprueba tu conexión a internet')
      }
      this.loading = false
    },
    attachURL (url) {
      let template_attribute = this.getAttribute('attachment')
      if (!template_attribute || !url.length) return;
      let value = JSON.parse(template_attribute.value)
      value.push(url)
      template_attribute.value = JSON.stringify(value)
      this.updateAttribute(this.block_id, this.template_id, template_attribute)
    },
    removeAttachment (index) {
      let template_attribute = this.getAttribute('attachment')
      if(template_attribute) {
        let value = JSON.parse(template_attribute.value)
        value.splice(index, 1);
        template_attribute.value = JSON.stringify(value)
        this.updateAttribute(this.block_id, this.template_id, template_attribute)
      }
    }
  },
  components: {
    'template-connector': Connector,
    TemplateTools,
  },
  created () {
    this.uuid = uuid('upload_image_xxxxxxxxxx')
    this.updateTemplateAttribute = _debounce((template_attribute, value) => {
      const attribute = JSON.parse(JSON.stringify(template_attribute))

      if (value && value.target) {
        attribute.value = value.target._value
      } else {
        attribute.value = value
      }

      this.updateAttribute(this.block_id, this.template_id, attribute).then(() => {
        this.$message.success('Actualizado')
      })
    }, 100, { leading: false, trailing: true })

    this.updateTemplateAttributeWithTime = _debounce((templateAttribute, value) => {
      const attribute = JSON.parse(JSON.stringify(templateAttribute))

      attribute.value = value

      this.updateAttribute(this.block_id, this.template_id, attribute).then(() => {
        this.$message.success('Actualizado')
      })
    }, 2000, { leading: false, trailing: true })
  },
  mounted () {
    this.$root.$on('bv::collapse::state', (collapseId) => {
      if (collapseId === `advance_search_collapse_${this.template_id}`) {
        setTimeout(() => {
          this.repaintBlock()
        }, 500)
      }
    })

    const self = this
    const templateAttribute = this.getAttribute('html')
    this.$nextTick(() => {
      const editor = pell.init({
        element: document.getElementById('html_' + this.uuid),
        onChange: html => {
          self.updateTemplateAttributeWithTime(templateAttribute, html)
        },
        actions: [
          'bold',
          'italic',
          'underline',
          'strikethrough',
          'olist',
          'ulist',
          {
            name: 'link',
            icon: '🔗',
            title: 'Link',
            result: () => {
              const url = window.prompt('Ingresa la URL:')
              if (url) pell.exec('createLink', url)
            }
          },
          {
            name: 'image',
            icon: '📷',
            title: 'Imagen',
            result: () => {
              const url = window.prompt('Ingresa la URL de la imagen:')
              if (url) pell.exec('insertImage', url)
            }
          }
        ],
        classes: {
          actionbar: ['d-flex justify-content-between border p-2 rounded-top'],
          button: 'btn btn-sm btn-soft-primary',
          selected: 'active',
          content: ['p-2 border border-top-0 rounded-bottom min-h-150']
        }
      })

      editor.content.innerHTML = templateAttribute ? templateAttribute.value : ''
    })
  },
}
</script>

<style lang="scss">
.pell-custom-button-selected, .pell-custom-button:hover {
  background-color: var(--secondary);
}

.min-h-150 {
  min-height: 150px;
}
</style>
